import { Colors } from './colors';
import { Fonts } from './fonts';
import { Tag } from './tag';

export const Tags: Tag[] = [
	{
		// STATUS RODADA DE INVESTIMENTOS
		STAND_BY: {
			font: Fonts.body2,
			color: Colors.amarelo,
			contrast: Colors.text,
			message: 'Stand By',
		},
		ON: {
			font: Fonts.body2,
			color: Colors.azul ,
			contrast: Colors.text,
			message: 'On',
		},
		SUCESSO: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Sucesso',
		},
		VENCEU: {
			font: Fonts.body2,
			color: Colors.amarelo,
			contrast: Colors.text,
			message: 'Venceu',
		},
		CANCELADA: {
			font: Fonts.body2,
			color: Colors.vermelho,
			contrast: Colors.text,
			message: 'Cancelada',
		},

		// STATUS CADASTROS DE INVESTIDOR E ASSESSOR
		ATIVO: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Ativo',
		},
		INATIVO: {
			font: Fonts.body2,
			color: Colors.vermelho,
			contrast: Colors.text,
			message: 'Inativo',
		},

    // SÓCIO RESPONSÁVEL
		SIM: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Sim',
		},
		NAO: {
			font: Fonts.body2,
			color: Colors.vermelho,
			contrast: Colors.text,
			message: 'Não',
		},

    // TIPO INVESTIDOR
    QUALIFICADO: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Qualificado',
		},
    MEDIO: {
			font: Fonts.body2,
			color: Colors.laranja,
			contrast: Colors.text,
			message: 'Médio',
		},
    PEQUENO: {
			font: Fonts.body2,
			color: Colors.amarelo,
			contrast: Colors.text,
			message: 'Pequeno',
		},

		// STATUS INVESTIMENTO
    EM_ANALISE: {
			font: Fonts.body2,
			color: Colors.azul,
			contrast: Colors.text,
			message: 'Análise',
		},
    ASSINADO: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Assinado',
		},
    AGUARDANDO_PAGAMENTO: {
			font: Fonts.body2,
			color: Colors.laranja,
			contrast: Colors.text,
			message: 'Aguardando',
		},
    PAGO: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Pago',
		},
    RECUSADO: {
			font: Fonts.body2,
			color: Colors.vermelho,
			contrast: Colors.text,
			message: 'Recusado',
		},
		CANCELADO: {
			font: Fonts.body2,
			color: Colors.amarelo,
			contrast: Colors.text,
			message: 'Cancelado',
		},

    // MOMENTO STARTUP
    PRE_SEED: {
			font: Fonts.body2,
			color: Colors.azul,
			contrast: Colors.text,
			message: 'Pré Seed',
		},
    SEED: {
			font: Fonts.body2,
			color: Colors.verde,
			contrast: Colors.text,
			message: 'Seed',
		},
    SERIES_A: {
			font: Fonts.body2,
			color: Colors.laranja,
			contrast: Colors.text,
			message: 'Séries A',
		},
    SERIES_B: {
			font: Fonts.body2,
			color: Colors.amarelo,
			contrast: Colors.text,
			message: 'Séries B',
		},
    SERIES_C: {
			font: Fonts.body2,
			color: Colors.fucsia,
			contrast: Colors.text,
			message: 'Séries C',
		},
	}
]
